
import { Vue } from 'vue-class-component';
import * as Theme from './presets';
import { Timer } from './timer';
import { START_PATH, STOP_PATH } from './main-button-path';
import { ClockModel } from './models';

export default class Clock extends Vue implements ClockModel {
  readonly queue = Timer.createTripleTimer(this);
  readonly leftTimer = this.queue[0];
  readonly middleTimer = this.queue[1];
  readonly rightTimer = this.queue[2];
  theme = Theme.ThemePicker.pick(Theme.lavender);
  settingsClicked = false;
  isRunning = false;
  mainBtn = START_PATH;
  current = 0;

  /**
   * When timer is up, this function needs to be invoked.
   */
  forcePause(): void {
    this.setStatusToPause();
    this.next();
  }

  private get currentTimer(): Timer {
    return this.queue[this.current];
  }

  private resetEveryTimer(): void {
    this.queue.forEach((timer) => timer.reset());
  }

  private isAllUp(): boolean {
    return this.queue.every((timer) => timer.isUp);
  }

  private next(): void {
    if (this.isAllUp()) {
      this.resetCurrent();
      return;
    }
    this.current = ++this.current % this.queue.length;
    if (this.currentTimer.isUp) {
      this.next();
    }
  }

  private resetCurrent(): void {
    if (this.currentTimer !== this.leftTimer) {
      this.current = 0;
    }
  }

  private startTimer(): void {
    if (this.isAllUp()) {
      this.pauseTimer();
      this.resetEveryTimer();
    }
    this.currentTimer.start();
  }

  private pauseTimer(): void {
    this.currentTimer.pause();
    this.next();
  }

  private setStatusToPause(): void {
    this.mainBtn = START_PATH;
    this.isRunning = false;
  }

  private setStatusToRunning(): void {
    this.mainBtn = STOP_PATH;
    this.isRunning = true;
  }

  onClickColorChange(): void {
    this.theme = Theme.ThemePicker.pickOne();
  }

  onClick(): void {
    if (this.isRunning) {
      this.setStatusToPause();
      this.pauseTimer();
    } else {
      this.setStatusToRunning();
      this.startTimer();
    }
  }

  onClickRestart(): void {
    this.setStatusToPause();
    this.pauseTimer();
    this.resetCurrent();
    this.resetEveryTimer();
  }

  onClickSettings(): void {
    this.settingsClicked = !this.settingsClicked;
  }
}
